
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acceptable-use-policy",
      function () {
        return require("private-next-pages/acceptable-use-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acceptable-use-policy"])
      });
    }
  